import { IVotingDetailResult } from "src/components/common/voting/types";

export const nullifyTopTraderProps = (result: IVotingDetailResult | null | undefined): IVotingDetailResult | null =>
    result
        ? {
              ...result,
              topTraderWikifolios: null,
              topTradersHaveVotedLikeUser: null,
          }
        : null;
